import React from 'react';
import { Button } from '@material-ui/core';

export default function EmailLink({ href, className, ...other }) {
    return (
        href && (<Button className={className} href={'mailto:' + href} color='primary' {...other} style={{ whiteSpace: 'normal', display: 'inline', verticalAlign: 'top' }}></Button>)
    )
}